/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: sMdpLWyxbzDCruwMRffW2m
// Component: 4t5SBkIXsA5h

import { pushSearchHistory } from "@/modules/search/functions/searchHistory";
import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { ApiRequest } from "@/common/fragment/components/api-request"; // plasmic-import: vW4UBuHCFshJ/codeComponent
import SearchContentSuggestion from "../../SearchContentSuggestion"; // plasmic-import: 6MD8zdNphdeG/component
import { SideEffect } from "@plasmicpkgs/plasmic-basic-components";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../fragment_design_system/plasmic.module.css"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectcss
import sty from "./PlasmicSearchResultQs.module.css"; // plasmic-import: 4t5SBkIXsA5h/css

import Icon14Icon from "./icons/PlasmicIcon__Icon14"; // plasmic-import: eKLBqU_Fr5SV/icon

import { uniq as __lib_lodash__uniq } from "lodash";
import { SEARCH_BOX_QS_REF, buildSearchBoxUrl } from "@/modules/search/functions/searchBoxUrl";

createPlasmicElementProxy;

export type PlasmicSearchResultQs__VariantMembers = {};
export type PlasmicSearchResultQs__VariantsArgs = {};
type VariantPropType = keyof PlasmicSearchResultQs__VariantsArgs;
export const PlasmicSearchResultQs__VariantProps = new Array<VariantPropType>();

export type PlasmicSearchResultQs__ArgsType = {
  terms?: string;
  onClick?: (value: string) => void;
  citySlug?: string;
};
type ArgPropType = keyof PlasmicSearchResultQs__ArgsType;
export const PlasmicSearchResultQs__ArgProps = new Array<ArgPropType>(
  "terms",
  "onClick",
  "citySlug"
);

export type PlasmicSearchResultQs__OverridesType = {
  root?: Flex__<"div">;
  serchiaSuggestion?: Flex__<typeof ApiRequest>;
  freeBox?: Flex__<"div">;
  svg?: Flex__<"svg">;
  searchContentSuggestion?: Flex__<typeof SearchContentSuggestion>;
  sendSplunkEvent?: Flex__<typeof SideEffect>;
};

export interface DefaultSearchResultQsProps {
  terms?: string;
  onClick?: (value: string) => void;
  citySlug?: string;
  className?: string;
}

const $$ = {
  lodash: {
    uniq: __lib_lodash__uniq
  }
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSearchResultQs__RenderFunc(props: {
  variants: PlasmicSearchResultQs__VariantsArgs;
  args: PlasmicSearchResultQs__ArgsType;
  overrides: PlasmicSearchResultQs__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          terms: ""
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const $globalActions = useGlobalActions?.();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "serchiaSuggestion.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "serchiaSuggestion"
      },
      {
        path: "serchiaSuggestion.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "serchiaSuggestion"
      },
      {
        path: "serchiaSuggestion.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "serchiaSuggestion"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root
      )}
    >
      <ApiRequest
        data-plasmic-name={"serchiaSuggestion"}
        data-plasmic-override={overrides.serchiaSuggestion}
        className={classNames("__wab_instance", sty.serchiaSuggestion)}
        config={(() => {
          try {
            return {
              ...$ctx.Fragment.apiConfig,
              headers: { apikey: "gwiuATzYDmeayT7eqmbHG2obv6lGpqJa" }
            };
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
        errorDisplay={null}
        loadingDisplay={
          <div
            data-plasmic-name={"freeBox"}
            data-plasmic-override={overrides.freeBox}
            className={classNames(projectcss.all, sty.freeBox)}
          >
            <Icon14Icon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />
          </div>
        }
        method={"GET"}
        onError={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, [
            "serchiaSuggestion",
            "error"
          ]).apply(null, eventArgs);
        }}
        onLoading={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, [
            "serchiaSuggestion",
            "loading"
          ]).apply(null, eventArgs);
        }}
        onSuccess={async (...eventArgs: any) => {
          generateStateOnChangeProp($state, [
            "serchiaSuggestion",
            "data"
          ]).apply(null, eventArgs);
        }}
        ref={ref => {
          $refs["serchiaSuggestion"] = ref;
        }}
        url={(() => {
          try {
            return (() => {
              return `https://apigw.paziresh24.com/v1/searchia-api/v2/qs/index/slim_clinic_query_su?query=${$props.terms || ""}&inContent=true&spellCheckEnabled=true`;
            })();
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return undefined;
            }
            throw e;
          }
        })()}
      >
        <SearchContentSuggestion
          data-plasmic-name={"searchContentSuggestion"}
          data-plasmic-override={overrides.searchContentSuggestion}
          className={classNames("__wab_instance", sty.searchContentSuggestion)}
          onClick={async value => {
            const $steps = {};

            $steps["localstorage"] = true
              ? (() => {
                  const actionArgs = {
                    customFunction: async () => {
                      return pushSearchHistory(value);
                    }
                  };
                  return (({ customFunction }) => {
                    return customFunction();
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["localstorage"] != null &&
              typeof $steps["localstorage"] === "object" &&
              typeof $steps["localstorage"].then === "function"
            ) {
              $steps["localstorage"] = await $steps["localstorage"];
            }

            $steps["goToPage"] = true
              ? (() => {
                  const actionArgs = {
                    destination: (() => {
                      try {
                        return buildSearchBoxUrl({
                          text: value,
                          ref: SEARCH_BOX_QS_REF,
                          citySlug: $props.citySlug
                        });
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()
                  };
                  return (({ destination }) => {
                    if (
                      typeof destination === "string" &&
                      destination.startsWith("#")
                    ) {
                      document
                        .getElementById(destination.substr(1))
                        .scrollIntoView({ behavior: "smooth" });
                    } else {
                      __nextRouter?.push(destination);
                    }
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["goToPage"] != null &&
              typeof $steps["goToPage"] === "object" &&
              typeof $steps["goToPage"].then === "function"
            ) {
              $steps["goToPage"] = await $steps["goToPage"];
            }

            $steps["runOnClick"] = true
              ? (() => {
                  const actionArgs = {
                    eventRef: $props["onClick"],
                    args: [
                      (() => {
                        try {
                          return value;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()
                    ]
                  };
                  return (({ eventRef, args }) => {
                    return eventRef?.(...(args ?? []));
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["runOnClick"] != null &&
              typeof $steps["runOnClick"] === "object" &&
              typeof $steps["runOnClick"].then === "function"
            ) {
              $steps["runOnClick"] = await $steps["runOnClick"];
            }
          }}
          topQuerySuggestions={(() => {
            try {
              return $state.serchiaSuggestion.data.entity.topQuerySuggestions
                .length > 0
                ? $state.serchiaSuggestion.data.entity.topQuerySuggestions
                : [$props.terms];
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        />

        <SideEffect
          data-plasmic-name={"sendSplunkEvent"}
          data-plasmic-override={overrides.sendSplunkEvent}
          className={classNames("__wab_instance", sty.sendSplunkEvent)}
          onMount={async () => {
            const $steps = {};

            $steps["sendSplunkQuerySuggestionViewEvent"] = !!$state
              .serchiaSuggestion.data.entity
              ? (() => {
                  const actionArgs = {
                    args: [
                      {
                        event_group: "search_metrics",
                        event_type: "suggestion_view",
                        current_url: window.location.href,
                        terminal_id: (function () {
                          try {
                            return document.cookie.replace(
                              /(?:(?:^|.*;\s*)terminal_id\s*\=\s*([^;]*).*$)|^.*$/,
                              "$1"
                            );
                          } catch (e) {
                            return null;
                          }
                        })(),
                        user_input: (function () {
                          try {
                            return $props.terms || "";
                          } catch (e) {
                            return "";
                          }
                        })(),
                        suggestions: (function () {
                          try {
                            var rawSuggestions =
                              $state.serchiaSuggestion.data.entity
                                .topQuerySuggestions;
                            if (!rawSuggestions) return [];
                            if (typeof rawSuggestions === "string") {
                              return JSON.parse(rawSuggestions);
                            }
                            return rawSuggestions;
                          } catch (e) {
                            return [];
                          }
                        })(),
                        suggestion_count: (function () {
                          try {
                            var raw =
                              $state.serchiaSuggestion.data.entity
                                .topQuerySuggestions;
                            if (!raw) return 0;
                            var list =
                              typeof raw === "string" ? JSON.parse(raw) : raw;
                            return list.length;
                          } catch (e) {
                            return 0;
                          }
                        })(),
                        city_id: (function () {
                          if (
                            $props &&
                            $props.selectedCity &&
                            $props.selectedCity.id
                          ) {
                            return $props.selectedCity.id;
                          }
                          if (
                            $props &&
                            $props.searchOptionalFilters &&
                            $props.searchOptionalFilters.city_id
                          ) {
                            return $props.searchOptionalFilters.city_id[0];
                          }
                          return -1;
                        })(),
                        userAgent: globalThis.navigator.userAgent
                          ? globalThis.navigator.userAgent
                          : "",
                        url: (function () {
                          const url = {
                            href: window.location.href,
                            query: {},
                            pathname: window.location.pathname,
                            host: window.location.host
                          };
                          try {
                            const urlParams = new URLSearchParams(
                              window.location.search
                            );
                            for (const [key, value] of urlParams.entries()) {
                              url.query[key] = value;
                            }
                          } catch (e) {}
                          return url;
                        })()
                      },
                      undefined,
                      "2ba8b09a-1f2d-4051-ad04-358636bf70f8"
                    ]
                  };
                  return $globalActions["Splunk.sendLog"]?.apply(null, [
                    ...actionArgs.args
                  ]);
                })()
              : undefined;
            if (
              $steps["sendSplunkQuerySuggestionViewEvent"] != null &&
              typeof $steps["sendSplunkQuerySuggestionViewEvent"] ===
                "object" &&
              typeof $steps["sendSplunkQuerySuggestionViewEvent"].then ===
                "function"
            ) {
              $steps["sendSplunkQuerySuggestionViewEvent"] =
                await $steps["sendSplunkQuerySuggestionViewEvent"];
            }
          }}
        />
      </ApiRequest>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "serchiaSuggestion",
    "freeBox",
    "svg",
    "searchContentSuggestion",
    "sendSplunkEvent"
  ],
  serchiaSuggestion: [
    "serchiaSuggestion",
    "freeBox",
    "svg",
    "searchContentSuggestion",
    "sendSplunkEvent"
  ],
  freeBox: ["freeBox", "svg"],
  svg: ["svg"],
  searchContentSuggestion: ["searchContentSuggestion"],
  sendSplunkEvent: ["sendSplunkEvent"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  serchiaSuggestion: typeof ApiRequest;
  freeBox: "div";
  svg: "svg";
  searchContentSuggestion: typeof SearchContentSuggestion;
  sendSplunkEvent: typeof SideEffect;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSearchResultQs__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSearchResultQs__VariantsArgs;
    args?: PlasmicSearchResultQs__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSearchResultQs__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSearchResultQs__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSearchResultQs__ArgProps,
          internalVariantPropNames: PlasmicSearchResultQs__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSearchResultQs__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSearchResultQs";
  } else {
    func.displayName = `PlasmicSearchResultQs.${nodeName}`;
  }
  return func;
}

export const PlasmicSearchResultQs = Object.assign(
  // Top-level PlasmicSearchResultQs renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    serchiaSuggestion: makeNodeComponent("serchiaSuggestion"),
    freeBox: makeNodeComponent("freeBox"),
    svg: makeNodeComponent("svg"),
    searchContentSuggestion: makeNodeComponent("searchContentSuggestion"),
    sendSplunkEvent: makeNodeComponent("sendSplunkEvent"),

    // Metadata about props expected for PlasmicSearchResultQs
    internalVariantProps: PlasmicSearchResultQs__VariantProps,
    internalArgProps: PlasmicSearchResultQs__ArgProps
  }
);

export default PlasmicSearchResultQs;
/* prettier-ignore-end */
